// Central i18n dictionary for the app (IT / EN)

export const translations = {
  it: {
    // Header
    app_name: "Riclassificatore Bilancio",
    app_subtitle: "IV Direttiva CEE — artt. 2424 e 2425 c.c.",
    lang_switch: "Lingua",
    // Landing
    hero_kicker: "Strumento professionale per commercialisti",
    hero_title_1: "Riclassifica il tuo bilancio",
    hero_title_2: "secondo lo schema civilistico.",
    hero_desc:
      "Carica il file Excel del bilancio, lascia che l'AI mappi ogni voce secondo la IV Direttiva CEE, correggi la mappatura e ottieni Stato Patrimoniale, Conto Economico e indici in pochi secondi.",
    cta_upload: "Carica il tuo bilancio",
    cta_learn: "Come funziona",
    feature_1_title: "AI Contabile",
    feature_1_desc: "Claude Sonnet 4.5 riconosce ogni voce e la mappa allo schema corretto.",
    feature_2_title: "Bilancio ordinario e abbreviato",
    feature_2_desc: "Supporto artt. 2424 e 2435-bis. Correggi le mappature prima della riclassificazione.",
    feature_3_title: "Indici di bilancio",
    feature_3_desc: "ROE, ROI, ROS, liquidità, solidità e rotazione con soglie di riferimento.",
    feature_4_title: "Export professionale",
    feature_4_desc: "Genera Excel dettagliato e PDF stile report ufficiale.",
    how_step_1: "Carica il tuo file Excel (.xls / .xlsx)",
    how_step_2: "Verifica la mappatura AI",
    how_step_3: "Scarica bilancio riclassificato e indici",
    trust_line: "Nessun login • Nessun dato salvato • Uso immediato",
    // Wizard
    step_upload: "Carica",
    step_mapping: "Verifica mappatura",
    step_results: "Risultati",
    // Prior year
    prior_upload_title: "Esercizi precedenti (N-1, N-2, …)",
    prior_upload_hint: "Opzionale — carica fino a 4 bilanci precedenti per il confronto e il trend",
    prior_add: "Aggiungi anno precedente",
    prior_uploaded: "voci estratte",
    prior_remove: "Rimuovi",
    prior_label: "Etichetta",
    xbrl_multi_period_title: "Rilevati più esercizi nel file XBRL",
    xbrl_multi_period_desc: "Ho impostato l'ultimo come anno corrente e gli altri come esercizi precedenti. Puoi rivedere prima di procedere.",
    delta_column: "Δ",
    delta_pct_column: "Δ %",
    prior_year_column: "N-1",
    current_year_column: "N",
    trend_title: "Trend multi-anno",
    trend_subtitle: "Evoluzione dei principali KPI e del rating Altman",
    trend_no_data: "Carica almeno 2 esercizi per vedere il trend",
    advisor_title: "Advisor AI · Commento automatico",
    advisor_subtitle: "Analisi interpretativa Claude su indici, trend e Altman Z-Score",
    advisor_generate: "Genera commento",
    advisor_regenerate: "Rigenera",
    advisor_generating: "L'AI sta analizzando il bilancio…",
    advisor_empty: "Clicca 'Genera commento' per ottenere l'analisi AI",
    advisor_error: "Errore nella generazione del commento AI",
    advisor_copy: "Copia",
    advisor_copied: "Copiato",
    advisor_include_pdf: "Includi nel PDF",
    advisor_included_hint: "Il commento AI sarà allegato al PDF esportato",
    period_months_label: "Periodo del bilancio (mesi)",
    period_months_hint: "Se il bilancio è infrannuale, verrà annualizzato per il calcolo degli indici",
    period_months_12: "12 — Bilancio annuale",
    period_months_9: "9 mesi",
    period_months_6: "6 mesi (semestrale)",
    period_months_3: "3 mesi (trimestrale)",
    annualized_badge: "CE annualizzato × 12/{m}",
    annualized_desc: "Voci del Conto Economico riproporzionate su base annua per indici coerenti",
    prov_column: "Provvisorio N",
    proj_column: "Proiezione fine anno",
    prov_hint: "Valore contabile del periodo caricato",
    proj_hint: "Valore proiettato a fine esercizio (× 12/mesi)",
    results_correctives: "Correttivi",
    corr_title: "Correttivi consigliati",
    corr_subtitle: "Confronto tra i valori attuali del CE e i target ottimali per il settore",
    corr_generate_ai: "Personalizza con AI",
    corr_regen_ai: "Rigenera con AI",
    corr_generating_ai: "Claude sta ricalibrando i target sulla realtà aziendale…",
    corr_include_pdf: "Includi nel PDF",
    corr_source_benchmark: "Target da benchmark di settore",
    corr_source_ai: "Target personalizzati da AI",
    corr_col_voce: "Voce",
    corr_col_current: "Attuale",
    corr_col_target: "Target ottimo",
    corr_col_delta: "Delta",
    corr_col_suggestion: "Suggerimento",
    corr_ebitda_label: "Margine EBITDA (A-B)",
    corr_delta_reduce: "da ridurre",
    corr_delta_grow: "da incrementare",
    corr_delta_keep: "in linea",
    corr_no_ricavi: "Il calcolo dei correttivi richiede almeno un ricavo positivo",
    tpl_title: "Template studio",
    tpl_hint: "Salva l'intestazione (logo, dati studio) e il settore per riusarli su più clienti",
    tpl_select_placeholder: "— Seleziona un template —",
    tpl_no_templates: "Nessun template salvato",
    tpl_save_new: "Salva come nuovo",
    tpl_update: "Aggiorna template",
    tpl_delete: "Elimina",
    tpl_prompt_name: "Nome del template (es. Studio Rossi)",
    tpl_saved: "Template salvato",
    tpl_updated: "Template aggiornato",
    tpl_deleted: "Template eliminato",
    tpl_loaded: "Template caricato",
    tpl_load: "Carica",
    results_roadmap: "Roadmap 12M",
    roadmap_title: "Roadmap 12 mesi",
    roadmap_subtitle: "Piano operativo Q1-Q4 generato con Claude Sonnet 4.5",
    roadmap_generate: "Genera roadmap con AI",
    roadmap_regenerate: "Rigenera roadmap",
    roadmap_generating: "Claude sta elaborando il piano trimestrale...",
    roadmap_generated: "Roadmap generata",
    roadmap_empty_title: "Nessuna roadmap ancora generata",
    roadmap_empty_desc: "Clicca 'Genera roadmap con AI' per creare un piano operativo Q1-Q4 basato su indici, correttivi e settore. Perfetto per allegarlo al report.",
    roadmap_impact: "Impatto atteso",
    roadmap_include_pdf: "Includi nel PDF",
    sparkline_col: "Trend",
    // Quadratura
    quadr_ok: "Bilancio quadrato",
    quadr_ko: "Sbilancio",
    quadr_ap: "Attivo − Passivo",
    quadr_utile: "Utile CE − Utile SP",
    quadr_check: "Verifica quadratura",
    // Upload
    upload_title: "Carica il file Excel del bilancio",
    upload_subtitle:
      "Formati supportati: .xlsx, .xls. Il file deve contenere una colonna con le descrizioni e una con gli importi.",
    upload_drop: "Trascina il file qui, oppure",
    upload_browse: "sfoglia dal computer",
    upload_hint: "Max 10MB — nessun file viene salvato sui nostri server",
    upload_type_ord: "Bilancio ordinario",
    upload_type_abb: "Bilancio abbreviato (2435-bis)",
    upload_type_label: "Tipo di bilancio",
    sector_label: "Settore ATECO (facoltativo)",
    sector_hint: "Adegua le soglie degli indici al settore",
    parsing: "Analisi del file in corso…",
    parsed_ok: "voci estratte dal file",
    resume_title: "Ripristina sessione precedente?",
    resume_desc: "Abbiamo trovato una mappatura non completata. Vuoi riprenderla?",
    resume_yes: "Riprendi",
    resume_no: "No, ricomincia",
    // Mapping
    mapping_title: "Verifica la mappatura AI",
    mapping_subtitle:
      "L'AI ha proposto una categoria per ogni voce. Correggi le mappature errate prima di procedere.",
    mapping_col_desc: "Descrizione voce",
    mapping_col_amount: "Importo",
    mapping_col_category: "Categoria IV Direttiva",
    mapping_col_confidence: "Confidenza",
    mapping_classifying: "Classificazione AI in corso…",
    mapping_select_placeholder: "Seleziona categoria",
    confirm_reclassify: "Genera bilancio riclassificato",
    back: "Indietro",
    search_placeholder: "Cerca voce…",
    // Results
    results_title: "Bilancio riclassificato",
    results_sp_attivo: "Stato Patrimoniale — Attivo",
    results_sp_passivo: "Stato Patrimoniale — Passivo",
    results_ce: "Conto Economico",
    results_indici: "Indici di Bilancio",
    voce: "Voce",
    importo: "Importo",
    total: "Totale",
    unclassified: "Voci non classificate",
    export_excel: "Scarica Excel",
    export_pdf: "Scarica PDF",
    new_analysis: "Nuova analisi",
    cover_title: "Copertina — Dati aziendali e periodo",
    cover_subtitle_hint: "Facoltativo — arricchisci l'export con logo, ragione sociale, periodo e anagrafica",
    cover_filled: "Dati compilati",
    cover_logo: "Logo aziendale",
    cover_logo_upload: "Carica logo",
    cover_logo_remove: "Rimuovi",
    cover_logo_hint: "PNG, JPG, WebP o SVG (max 2MB)",
    cover_company_name: "Ragione sociale",
    cover_period_from: "Periodo — dal",
    cover_period_to: "Periodo — al",
    cover_vat: "Partita IVA",
    cover_cf: "Codice Fiscale",
    cover_cciaa: "Iscrizione CCIAA (n. REA)",
    cover_address: "Sede legale (indirizzo)",
    cover_phone: "Telefono",
    cover_email: "Email",
    cover_website: "Sito web",
    cover_generated_at: "Data documento",
    group_redditivita: "Redditività",
    group_liquidita: "Liquidità",
    group_solidita: "Solidità",
    group_rotazione: "Rotazione",
    altman_title: "Rating Creditizio — Altman Z'-Score",
    altman_score: "Punteggio Z'",
    altman_zone: "Fascia",
    altman_zone_safe: "Zona di Sicurezza",
    altman_zone_grey: "Zona Grigia",
    altman_zone_distress: "Zona di Rischio",
    altman_desc_safe: "Bassa probabilità di insolvenza — situazione finanziaria sana",
    altman_desc_grey: "Situazione da monitorare, alcuni segnali di attenzione",
    altman_desc_distress: "Elevata probabilità di insolvenza — attenzione critica richiesta",
    altman_components: "Componenti del calcolo",
    formula: "Formula",
    value: "Valore",
    na: "N/D",
    // errors
    err_generic: "Si è verificato un errore. Riprova.",
    err_file_type: "Il file deve essere .xls o .xlsx",
    toast_upload_ok: "File analizzato correttamente",
    toast_classify_ok: "Mappatura AI completata",
    toast_export_ok: "Download avviato",
    toast_export_err: "Errore durante l'export",
  },
  en: {
    app_name: "Balance Sheet Reclassifier",
    app_subtitle: "Italian GAAP — Civil Code arts. 2424 & 2425",
    lang_switch: "Language",
    hero_kicker: "Professional tool for accountants",
    hero_title_1: "Reclassify your balance sheet",
    hero_title_2: "to the Italian civil code schema.",
    hero_desc:
      "Upload the Excel balance sheet, let AI map each line item to the Italian IV Direttiva schema, correct any mapping and get Assets, Liabilities, Income Statement and financial ratios in seconds.",
    cta_upload: "Upload your balance sheet",
    cta_learn: "How it works",
    feature_1_title: "Accounting AI",
    feature_1_desc: "Claude Sonnet 4.5 recognises each item and maps it to the correct schema.",
    feature_2_title: "Ordinary & abbreviated",
    feature_2_desc: "Supports arts. 2424 and 2435-bis. Correct mappings before reclassification.",
    feature_3_title: "Financial ratios",
    feature_3_desc: "ROE, ROI, ROS, liquidity, solidity and turnover with reference thresholds.",
    feature_4_title: "Professional export",
    feature_4_desc: "Generate detailed Excel and PDF in official report style.",
    how_step_1: "Upload your Excel file (.xls / .xlsx)",
    how_step_2: "Review the AI mapping",
    how_step_3: "Download reclassified statements & ratios",
    trust_line: "No login • No data stored • Instant use",
    step_upload: "Upload",
    step_mapping: "Review mapping",
    step_results: "Results",
    prior_upload_title: "Prior years (N-1, N-2, …)",
    prior_upload_hint: "Optional — upload up to 4 prior balance sheets for comparison and trend",
    prior_add: "Add prior year",
    prior_uploaded: "items extracted",
    prior_remove: "Remove",
    prior_label: "Label",
    xbrl_multi_period_title: "Multiple periods detected in XBRL file",
    xbrl_multi_period_desc: "I set the most recent as current year and the others as prior years. Review before proceeding.",
    delta_column: "Δ",
    delta_pct_column: "Δ %",
    prior_year_column: "N-1",
    current_year_column: "N",
    trend_title: "Multi-year trend",
    trend_subtitle: "Evolution of key KPIs and Altman rating",
    trend_no_data: "Upload at least 2 years to see the trend",
    advisor_title: "AI Advisor · Automated commentary",
    advisor_subtitle: "Interpretive analysis by Claude on ratios, trends and Altman Z-Score",
    advisor_generate: "Generate commentary",
    advisor_regenerate: "Regenerate",
    advisor_generating: "AI is analysing the balance sheet…",
    advisor_empty: "Click 'Generate commentary' for AI analysis",
    advisor_error: "AI commentary generation failed",
    advisor_copy: "Copy",
    advisor_copied: "Copied",
    advisor_include_pdf: "Include in PDF",
    advisor_included_hint: "The AI commentary will be appended to the exported PDF",
    period_months_label: "Statement period (months)",
    period_months_hint: "If interim, values are annualized for accurate ratios",
    period_months_12: "12 — Full year",
    period_months_9: "9 months",
    period_months_6: "6 months (semi-annual)",
    period_months_3: "3 months (quarterly)",
    annualized_badge: "P&L annualized × 12/{m}",
    annualized_desc: "Income Statement items scaled to annual basis for consistent ratios",
    prov_column: "Interim N",
    proj_column: "Year-end projection",
    prov_hint: "Actual value of the loaded period",
    proj_hint: "Projected year-end value (× 12/months)",
    results_correctives: "Corrections",
    corr_title: "Recommended corrections",
    corr_subtitle: "Comparison between actual P&L values and optimal sector targets",
    corr_generate_ai: "Personalize with AI",
    corr_regen_ai: "Regenerate with AI",
    corr_generating_ai: "Claude is recalibrating targets to company reality…",
    corr_include_pdf: "Include in PDF",
    corr_source_benchmark: "Targets from sector benchmark",
    corr_source_ai: "AI-personalized targets",
    corr_col_voce: "Item",
    corr_col_current: "Actual",
    corr_col_target: "Optimal target",
    corr_col_delta: "Delta",
    corr_col_suggestion: "Suggestion",
    corr_ebitda_label: "EBITDA margin (A-B)",
    corr_delta_reduce: "reduce",
    corr_delta_grow: "grow",
    corr_delta_keep: "on target",
    corr_no_ricavi: "Correctives require positive revenues to compute",
    tpl_title: "Firm templates",
    tpl_hint: "Save your firm's letterhead (logo, contacts) and default sector to reuse across clients",
    tpl_select_placeholder: "— Select a template —",
    tpl_no_templates: "No templates saved",
    tpl_save_new: "Save as new",
    tpl_update: "Update template",
    tpl_delete: "Delete",
    tpl_prompt_name: "Template name (e.g. Studio Rossi)",
    tpl_saved: "Template saved",
    tpl_updated: "Template updated",
    tpl_deleted: "Template deleted",
    tpl_loaded: "Template loaded",
    tpl_load: "Load",
    results_roadmap: "Roadmap 12M",
    roadmap_title: "12-month Roadmap",
    roadmap_subtitle: "Q1-Q4 operational plan generated with Claude Sonnet 4.5",
    roadmap_generate: "Generate roadmap with AI",
    roadmap_regenerate: "Regenerate roadmap",
    roadmap_generating: "Claude is drafting the quarterly plan...",
    roadmap_generated: "Roadmap generated",
    roadmap_empty_title: "No roadmap generated yet",
    roadmap_empty_desc: "Click 'Generate roadmap with AI' to build a Q1-Q4 operational plan from ratios, correctives and sector. Perfect to attach to the report.",
    roadmap_impact: "Expected impact",
    roadmap_include_pdf: "Include in PDF",
    sparkline_col: "Trend",
    quadr_ok: "Balance sheet balanced",
    quadr_ko: "Imbalance",
    quadr_ap: "Assets − Liabilities",
    quadr_utile: "Income Statement Profit − Balance Sheet Profit",
    quadr_check: "Balance check",
    upload_title: "Upload the balance sheet Excel",
    upload_subtitle:
      "Supported formats: .xlsx, .xls. The file should contain one column with descriptions and one with amounts.",
    upload_drop: "Drag file here, or",
    upload_browse: "browse from your computer",
    upload_hint: "Max 10MB — files are never stored on our servers",
    upload_type_ord: "Ordinary",
    upload_type_abb: "Abbreviated (2435-bis)",
    upload_type_label: "Statement type",
    sector_label: "Industry sector (optional)",
    sector_hint: "Adjust ratio thresholds to the sector",
    parsing: "Analysing file…",
    parsed_ok: "items extracted from file",
    resume_title: "Restore previous session?",
    resume_desc: "We found an unfinished mapping. Continue where you left off?",
    resume_yes: "Resume",
    resume_no: "Start fresh",
    mapping_title: "Review AI mapping",
    mapping_subtitle:
      "AI proposed a category for each item. Correct any wrong mapping before continuing.",
    mapping_col_desc: "Line item description",
    mapping_col_amount: "Amount",
    mapping_col_category: "IV Direttiva Category",
    mapping_col_confidence: "Confidence",
    mapping_classifying: "AI is classifying…",
    mapping_select_placeholder: "Select category",
    confirm_reclassify: "Generate reclassified statements",
    back: "Back",
    search_placeholder: "Search item…",
    results_title: "Reclassified statements",
    results_sp_attivo: "Balance Sheet — Assets",
    results_sp_passivo: "Balance Sheet — Liabilities & Equity",
    results_ce: "Income Statement",
    results_indici: "Financial Ratios",
    voce: "Item",
    importo: "Amount",
    total: "Total",
    unclassified: "Unclassified items",
    export_excel: "Download Excel",
    export_pdf: "Download PDF",
    new_analysis: "New analysis",
    cover_title: "Cover — Company details & period",
    cover_subtitle_hint: "Optional — enrich the export with logo, company name, period and details",
    cover_filled: "Details filled",
    cover_logo: "Company logo",
    cover_logo_upload: "Upload logo",
    cover_logo_remove: "Remove",
    cover_logo_hint: "PNG, JPG, WebP or SVG (max 2MB)",
    cover_company_name: "Company name",
    cover_period_from: "Period — from",
    cover_period_to: "Period — to",
    cover_vat: "VAT Number",
    cover_cf: "Fiscal Code",
    cover_cciaa: "Chamber of Commerce (REA)",
    cover_address: "Registered address",
    cover_phone: "Phone",
    cover_email: "Email",
    cover_website: "Website",
    cover_generated_at: "Document date",
    group_redditivita: "Profitability",
    group_liquidita: "Liquidity",
    group_solidita: "Solidity",
    group_rotazione: "Turnover",
    altman_title: "Credit Rating — Altman Z'-Score",
    altman_score: "Z' Score",
    altman_zone: "Zone",
    altman_zone_safe: "Safe Zone",
    altman_zone_grey: "Grey Zone",
    altman_zone_distress: "Distress Zone",
    altman_desc_safe: "Low probability of default — healthy financial position",
    altman_desc_grey: "Monitor closely, some early warning signals",
    altman_desc_distress: "High probability of default — critical attention required",
    altman_components: "Score components",
    formula: "Formula",
    value: "Value",
    na: "N/A",
    err_generic: "Something went wrong. Try again.",
    err_file_type: "File must be .xls or .xlsx",
    toast_upload_ok: "File parsed successfully",
    toast_classify_ok: "AI mapping complete",
    toast_export_ok: "Download started",
    toast_export_err: "Export failed",
  },
};

export const formatEUR = (value, lang = "it") => {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const loc = lang === "en" ? "en-US" : "it-IT";
  return new Intl.NumberFormat(loc, {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
  }).format(value);
};
